import React, { type ReactNode } from "react";
import { Box, Container } from "@mui/material";
import { alpha } from "@mui/material/styles";
import Topbar from "../Navigation/Topbar";
import WelcomeFooter from "../Welcome/WelcomeFooter";
import {
  authBackgroundContainerSx,
  authOrb1Sx,
  authOrb2Sx
} from "../common/AuthSidePanel/authBackgroundStyles";
import {
  PUBLIC_INFO_PAGE_MAX_WIDTH,
  publicInfoContentSx
} from "./constants/publicInfoPageStyles";

type PublicMarketingLayoutProps = {
  children: ReactNode;
};

const PublicMarketingLayout: React.FC<PublicMarketingLayoutProps> = ({
  children
}) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh"
    }}
  >
    <Topbar
      isMembership
      showMembershipSubNav={false}
      openFlyOver={() => undefined}
      showMenuIcon={false}
    />
    <Box
      sx={{
        ...authBackgroundContainerSx,
        flex: 1,
        minHeight: 0,
        py: { xs: 3, sm: 5 },
        display: "flex",
        flexDirection: "column"
      }}
    >
      <Box sx={authOrb1Sx} />
      <Box sx={authOrb2Sx} />
      <Container
        maxWidth={PUBLIC_INFO_PAGE_MAX_WIDTH}
        sx={{
          position: "relative",
          zIndex: 1,
          flex: 1,
          display: "flex",
          flexDirection: "column"
        }}
      >
        <Box
          sx={{
            position: "relative",
            borderRadius: "5px",
            backgroundColor: alpha("#fff", 0.96),
            backdropFilter: "saturate(180%) blur(14px)",
            WebkitBackdropFilter: "saturate(180%) blur(14px)",
            border: `1px solid ${alpha("#fff", 0.65)}`,
            boxShadow: `0 16px 48px ${alpha("#1a0a3e", 0.14)}`,
            p: { xs: 2.5, sm: 4, md: 5 },
            mb: { xs: 2, sm: 3 },
            flex: 1,
            minHeight: { xs: 420, sm: 480 },
            overflow: "hidden",
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: 4,
              background: "linear-gradient(90deg, #6f49c9 0%, #667eea 100%)"
            }
          }}
        >
          <Box sx={publicInfoContentSx}>{children}</Box>
        </Box>
      </Container>
    </Box>
    <WelcomeFooter />
  </Box>
);

export default PublicMarketingLayout;
